export { default } from './BarchartWidget';
